import appConfig from '@/utils/appConfig'

// Product/company name shown in the UI, exports and PDF reports.
// Imported explicitly (not via Vue.prototype) so it also resolves in the
// Module Federation PDF context, where main.js never runs.
// The `||` is not redundant with the schema default: env-schema only fills a
// var that is absent from process.env, so a config declaring the key with an
// empty value would otherwise blank out every branded string.
export const BRAND_NAME = appConfig.VUE_APP_BRAND_NAME || 'Global Ledger'

// External logo overrides. Empty string = fall back to the bundled themed SVG.
// Full = expanded logo (sidebar, public case header, connect pages, graph watermark),
// short = collapsed sidebar mark. Rendered through @/components/gl-brand-logo.
export const BRAND_LOGO_URL = appConfig.VUE_APP_BRAND_LOGO_URL || ''
export const BRAND_LOGO_SHORT_URL = appConfig.VUE_APP_BRAND_LOGO_SHORT_URL || ''

// Overrides the per-theme favicon wired up in app.vue.
export const BRAND_FAVICON_URL = appConfig.VUE_APP_BRAND_FAVICON_URL || ''
